module.exports = __webpack_public_path__ + "static/media/maintenance-1.b9ce9cb2.jpg";